(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-video"] && !Shopify.designMode) return;
  try {
    
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-campaign-video] video[autoplay]').forEach((video) => {
      video.autoplay = false;
      video.pause();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
